import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, serializeDataIfNeeded } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const TemporaryFileUploadControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {TemporaryFileUploadControllerApiCreateTemporaryFileByPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTemporaryFileByPreSignedUrl: ({ temporaryFilePreSignedCreateRequest }, options = {}) => {
      assertParamExists("createTemporaryFileByPreSignedUrl", "temporaryFilePreSignedCreateRequest", temporaryFilePreSignedCreateRequest);
      const localVarPath = `/api/v2/file/users/me/files/temporary/pre-signed-url`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(temporaryFilePreSignedCreateRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "createTemporaryFileByPreSignedUrl",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiCreateTemporaryFileMultipartPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTemporaryFileMultipartPreSignedUrl: ({ temporaryFileMultipartPreSignedCreateDto }, options = {}) => {
      assertParamExists("createTemporaryFileMultipartPreSignedUrl", "temporaryFileMultipartPreSignedCreateDto", temporaryFileMultipartPreSignedCreateDto);
      const localVarPath = `/api/v2/file/users/me/files/temporary/pre-signed-url/multipart`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(temporaryFileMultipartPreSignedCreateDto, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "createTemporaryFileMultipartPreSignedUrl",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiVerifyTemporaryFileMultipartPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyTemporaryFileMultipartPreSignedUrl: ({ temporaryFileMultipartPreSignedVerificationDto }, options = {}) => {
      assertParamExists("verifyTemporaryFileMultipartPreSignedUrl", "temporaryFileMultipartPreSignedVerificationDto", temporaryFileMultipartPreSignedVerificationDto);
      const localVarPath = `/api/v2/file/users/me/files/temporary/pre-signed-url/multipart/verify`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(temporaryFileMultipartPreSignedVerificationDto, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "verifyTemporaryFileMultipartPreSignedUrl",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiVerifyTemporaryFilePreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyTemporaryFilePreSignedUrl: ({ fileKey }, options = {}) => {
      assertParamExists("verifyTemporaryFilePreSignedUrl", "fileKey", fileKey);
      const localVarPath = `/api/v2/file/users/me/files/temporary/{fileKey}/pre-signed-url/verify`.replace(`{${"fileKey"}}`, encodeURIComponent(String(fileKey)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "verifyTemporaryFilePreSignedUrl",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const TemporaryFileUploadControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = TemporaryFileUploadControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {TemporaryFileUploadControllerApiCreateTemporaryFileByPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTemporaryFileByPreSignedUrl(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.createTemporaryFileByPreSignedUrl(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiCreateTemporaryFileMultipartPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTemporaryFileMultipartPreSignedUrl(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.createTemporaryFileMultipartPreSignedUrl(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiVerifyTemporaryFileMultipartPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyTemporaryFileMultipartPreSignedUrl(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.verifyTemporaryFileMultipartPreSignedUrl(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {TemporaryFileUploadControllerApiVerifyTemporaryFilePreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyTemporaryFilePreSignedUrl(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.verifyTemporaryFilePreSignedUrl(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const createTemporaryFileByPreSignedUrlRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: TemporaryFileUploadControllerApiAxiosParamCreator().createTemporaryFileByPreSignedUrl,
  requestFn: TemporaryFileUploadControllerApiFp().createTemporaryFileByPreSignedUrl
});
const createTemporaryFileMultipartPreSignedUrlRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: TemporaryFileUploadControllerApiAxiosParamCreator().createTemporaryFileMultipartPreSignedUrl,
  requestFn: TemporaryFileUploadControllerApiFp().createTemporaryFileMultipartPreSignedUrl
});
const verifyTemporaryFileMultipartPreSignedUrlRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: TemporaryFileUploadControllerApiAxiosParamCreator().verifyTemporaryFileMultipartPreSignedUrl,
  requestFn: TemporaryFileUploadControllerApiFp().verifyTemporaryFileMultipartPreSignedUrl
});
const verifyTemporaryFilePreSignedUrlRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: TemporaryFileUploadControllerApiAxiosParamCreator().verifyTemporaryFilePreSignedUrl,
  requestFn: TemporaryFileUploadControllerApiFp().verifyTemporaryFilePreSignedUrl
});

export { TemporaryFileUploadControllerApiAxiosParamCreator, TemporaryFileUploadControllerApiFp, createTemporaryFileByPreSignedUrlRemote, createTemporaryFileMultipartPreSignedUrlRemote, verifyTemporaryFileMultipartPreSignedUrlRemote, verifyTemporaryFilePreSignedUrlRemote };
//# sourceMappingURL=temporary-file-upload-controller-api.mjs.map
